module.exports = __webpack_public_path__ + "static/media/icons_Bilan bronchiolite et affections respiratoires.debb32b3.svg";